angular.module("whitelabelApp")
    .controller("LandingController", ['$scope', '$routeParams', function($scope, $routeParams){
        $scope.name = 'LandingController';
        $scope.params = $routeParams;
    }]);
    